import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo, Nullable, Object_Unknown } from "../../base-types";

@JsonObject()
export class FacetResponseResource {
    @JsonProperty("id")
    id: Nullable<number> = null;

    @JsonProperty("value")
    value: string;

    @JsonProperty("labels")
    labels: MapCultureTo<string> = {};

    @JsonProperty("name")
    fieldName: string;

    @JsonProperty("addQuery")
    addQuery: string;

    @JsonProperty("childCount")
    totalNumberOfFacetValues: number;

    @JsonProperty("ispartial")
    isPartial: boolean = false;

    @JsonProperty("limit")
    limit: number;

    @JsonProperty("matchCount")
    matchCount: number;

    @JsonProperty("children")
    @JsonElementType(FacetResponseResource)
    children: Array<FacetResponseResource> = [];

    @JsonProperty("definition")
    definition: string;

    @JsonProperty("position")
    position: string;

    @JsonProperty("multi_select_enabled")
    multiSelectEnabled: boolean = false;

    @JsonProperty("checked")
    checked: boolean = false;

    @JsonProperty("multi_select_empty_query")
    multiSelectEmptyQuery: string;

    @JsonProperty("has_descendants")
    hasDescendants: boolean = false;

    @JsonProperty("data")
    data?: Object_Unknown;
}
